const routes = [
  {
    path: '/citas-por-fecha',
    name: 'Citas',
    component: () => import('@/views/reportes/CitasPorFecha.vue'),
    meta: { title: 'Citas por Fecha' }
  },
  {
    path: '/atenciones-por-fecha',
    name: 'Atenciones',
    component: () => import('@/views/reportes/AtencionesPorFecha.vue'),
    meta: { title: 'Atenciones por Fecha' }
  },
  {
    path: '/atenciones-fin-sin-diag',
    name: 'Atenciones sin Diag',
    component: () => import('@/views/reportes/AtencionesFinSinDiag.vue'),
    meta: { title: 'Citas finalizadas sin Diag' }
  },
  {
    path: '/interconsultas-por-fecha',
    name: 'Interconsultas',
    component: () => import('@/views/reportes/InterconsultasPorFecha.vue'),
    meta: { title: 'Interconsultas por Fecha' }
  },
  {
    path: '/referencias-por-fecha',
    name: 'Referencias',
    component: () => import('@/views/reportes/ReferenciasPorFecha.vue'),
    meta: { title: 'Referencias Por Fecha' }
  },
];

export { routes };
